import React, { FC } from 'react';
import { ExportOutlined } from 'common/const/svg';
import { EPatientDetailsItemLabel } from 'entities/Patient/Patient.enum';
import { patientDataToDetails } from 'entities/Patient/Patient.helper';
import { IPatient } from 'entities/Patient/Patient.models';

interface IComponentProps {
  patient: IPatient | null;
  ccdaLink?: string;
}

export const PatientDetails: FC<IComponentProps> = ({ patient, ccdaLink }) => {
  const details = patientDataToDetails(patient);

  return (
    <div className="d-flex align-start justify-between patient-details">
      <div className="d-flex align-center flex-wrap patient-details__container">
        {Object.entries(details).map(([key, value], index) => {
          return (
            <div key={index}>
              <span className="ff-regular fs-sm color-grey">
                {`${EPatientDetailsItemLabel[key as keyof typeof EPatientDetailsItemLabel]}: `}
              </span>

              <span className="ff-regular fs-sm">{value}</span>
            </div>
          );
        })}
      </div>

      {ccdaLink && (
        <a className="ff-regular fs-sm" onClick={() => window.open(ccdaLink, '_blank')}>
          <span>Celeri Patient Details</span>

          <ExportOutlined />
        </a>
      )}

      {patient && (
        <a
          className="ff-regular fs-sm"
          onClick={() => window.open(`https://dev.celerihealth.com/home/resources/patients/${patient.id}`, '_blank')}
        >
          <span>Celeri Patient Detail</span>

          <ExportOutlined />
        </a>
      )}
    </div>
  );
};
